export default "<div class=\"p-container\">\n    <p class=\"p-timer\">Time - {{display}}</p> \n</div>"